import { styleStat, stylePlayerStat, styleCoinStat } from "../../../utils/parser";
import { Container, Text } from "../../../types";
import { TILE_WIDTH, IStat, IStats } from "../../../data/settings";

const textStyle = {
  fillStyle: "white",
  fontFamily: "'Oswald', sans-serif",
  fontSize: "26px",
};

export const descriptionStyle = { ...textStyle, fontSize: "12px" };
export type LevelText = [Phaser.GameObjects.Rectangle, Phaser.GameObjects.Text];
export function addLevelText(scene: Phaser.Scene): LevelText {
  const w = 10 * TILE_WIDTH;
  const text: LevelText = [
    scene.add.rectangle(0, TILE_WIDTH, w, 60, 0x000).setAlpha(0.5).setDepth(99),
    scene.add.text(2 * TILE_WIDTH, TILE_WIDTH - 15, "", textStyle).setDepth(99),
  ];
  return text;
}

const levelLabels = ["Forward", "Rewind", "Getting the hang of it"];

export function showLevelText(scene: Phaser.Scene, level: number, text = addLevelText(scene)) {
  // fade in and display current level
  scene.cameras.main.fadeIn(750);
  text?.forEach((o) => o.setAlpha(1));
  text[1].setText(`Level ${level + 1}: ${levelLabels[level] ?? ""}`);
  // TODO
  scene.cameras.main.once("camerafadeincomplete", () => {
    scene.tweens.add({
      targets: text,
      alpha: 0,
      duration: 750,
      ease: "Power2",
    });
  });
}

/**
 * new functions start here
 * */

export function reverseText(textObject?: Text) {
  if (!textObject) return;
  const newText = styleStat(-1 * +textObject.text.replace("+", ""));
  textObject.setText(newText);
}

export function updateStat(card: Container, key: keyof IStats, value: number) {
  const stat = card.getByName(key) as Text;
  if (!stat) return value;

  const storedValue: IStat = card.getData(key) ?? 0;
  if (typeof storedValue === "number") {
    const newValue = Math.max(value, 0);
    const newText = `${newValue}`;

    stat.setText(newText);
    stat.setVisible(newValue !== 0);
    card.setData(key, newValue);

    return newValue;
  }
  const [, max] = storedValue;
  const newValue = Math.max(Math.min(value, max), 0);
  const newEntry = [newValue, max] as [number, number];
  let newText = stylePlayerStat(newEntry);
  if (key === "coin") {
    newText = styleCoinStat(newEntry);
    stat.setVisible(newValue !== 0);
  }
  stat.setText(newText);
  card.setData(key, newEntry);

  return newValue;
}
